const createLeaguesStore = (set) => ({
  leaguesList: undefined,
  isLoading: false,

  setLeagues: (leagues) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        leagues: {
          ...state.superadmin.leagues,
          leaguesList: leagues,
        },
      },
    })),

  setLoading: (isLoading) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        leagues: {
          ...state.superadmin.leagues,
          isLoading,
        },
      },
    })),

  // Reset store to initial state
  reset: () =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        leagues: {
          leaguesList: [],
          isLoading: false,
        },
      },
    })),
});

export default createLeaguesStore;
